import React from 'react';
import { useCart } from '../../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { adminCouponAPI } from '../../../admin/Handlers/couponAPI';
import {
    FaTrash,
    FaShieldHalved,
    FaLock,
    FaTruck,
    FaArrowLeft,
    FaBagShopping,
    FaMinus,
    FaPlus
} from 'react-icons/fa6';
import styles from './CartPage.module.css';
import { useState } from 'react';


function CartPage() {
    const navigate = useNavigate();
    const {
        cartItems,
        removeFromCart,
        updateQuantity,
        loading,
        subtotal,
        selectedShipping,
        totalOrder
    } = useCart();


    const [couponCode, setCouponCode] = useState('');
    const [couponLoading, setCouponLoading] = useState(false);
    const [couponError, setCouponError] = useState('');
    const [couponData, setCouponData] = useState(null);
    const discountValue = couponData?.discount || 0;
    const totalWithDiscount = totalOrder - discountValue;

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

    // Função para garantir que a atualização de quantidade funcione
    const handleQuantityChange = (id, currentQty, delta) => {
        const newQty = currentQty + delta;
        if (newQty >= 1) {
            updateQuantity(id, newQty);
        }
    };

    if (loading && (!cartItems || cartItems.length === 0)) {
        return (
            <div className={styles.loaderContainer}>
                <div className={styles.spinner}></div>
                <p>Sincronizando arsenal...</p>
            </div>
        );
    }
    const applyCoupon = async () => {
        const code = couponCode.trim().toUpperCase();
        if (!code) return;

        setCouponLoading(true);
        setCouponError('');

        try {
            const data = await adminCouponAPI.apply({
                code,
                subtotal
            });

            console.debug('CartPage.applyCoupon received', data);

            if (!data?.valid) {
                throw new Error(data?.error || 'Cupom inválido');
            }

            setCouponData(data);

        } catch (err) {
            console.debug('CartPage.applyCoupon error', err);
            setCouponError(
                err?.response?.data?.error ||
                err?.message ||
                'Erro ao aplicar cupom'
            );
            setCouponData(null);
        } finally {
            setCouponLoading(false);
        }
    };


    if (!cartItems || cartItems.length === 0) {
        return (
            <div className={styles.emptyContainer}>
                <div className={styles.emptyContent}>
                    <div className={styles.iconWrapper}>
                        <FaBagShopping />
                        <div className={styles.iconRing}></div>
                    </div>

                    <h2 className={styles.emptyTitle}>
                        SEU ARSENAL ESTÁ <span>VAZIO.</span>
                    </h2>

                    <p className={styles.emptyText}>
                        O campo de batalha não perdoa os despreparados. <br />
                        Selecione seu equipamento e esteja pronto para qualquer missão.
                    </p>

                    <button
                        className={styles.exploreBtn}
                        onClick={() => navigate('/products')}
                    >
                        EXPLORAR EQUIPAMENTOS
                        <div className={styles.btnEffect}></div>
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.container}>
                <header className={styles.header}>
                    <button className={styles.backBtn} onClick={() => navigate('/products')}>
                        <FaArrowLeft /> CONTINUAR COMPRANDO
                    </button>
                    <h1 className={styles.title}>MEU <span>CARRINHO.</span></h1>
                </header>

                <div className={styles.contentGrid}>
                    {/* LISTA DE PRODUTOS */}
                    <main className={styles.cartList}>
                        {cartItems.map((item) => (
                            <div key={item.id} className={styles.productRow}>
                                <div className={styles.imgContainer}>
                                    <img
                                        src={item.product_details?.image_url
                                            ? `${API_BASE_URL}${item.product_details.image_url}`
                                            : 'https://via.placeholder.com/150'}
                                        alt={item.product_details?.name}
                                    />
                                </div>

                                <div className={styles.productInfo}>
                                    <div className={styles.infoHead}>
                                        <h3>{item.product_details?.name || 'Equipamento Jungle'}</h3>
                                        <p className={styles.optionTag}>OPÇÃO: {item.option || 'Padrão'}</p>
                                    </div>

                                    <div className={styles.infoActions}>
                                        <div className={styles.quantityControl}>
                                            <button
                                                onClick={() => handleQuantityChange(item.id, item.quantity, -1)}
                                                disabled={item.quantity <= 1}
                                            >
                                                <FaMinus />
                                            </button>
                                            <span>{item.quantity}</span>
                                            <button
                                                onClick={() => handleQuantityChange(item.id, item.quantity, 1)}
                                                disabled={item.product_details?.stock_quantity <= item.quantity}
                                            >
                                                <FaPlus />
                                            </button>
                                        </div>

                                        <div className={styles.priceContainer}>
                                            <span className={styles.subtotalItem}>
                                                R$ {(item.product_details?.price * item.quantity || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                            </span>
                                        </div>

                                        <button
                                            className={styles.removeBtn}
                                            onClick={() => removeFromCart(item.id)}
                                        >
                                            <FaTrash />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </main>

                    {/* SIDEBAR DE RESUMO */}
                    <aside className={styles.sidebar}>
                        <div className={styles.summaryCard}>
                            <h2 className={styles.summaryTitle}>RESUMO DO PEDIDO</h2>

                            <div className={styles.summaryLine}>
                                <span>Subtotal</span>
                                <span>R$ {subtotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                            </div>

                            <div className={styles.summaryLine}>
                                <span><FaTruck /> Frete</span>
                                {selectedShipping ? (
                                    <span>R$ {selectedShipping?.preco?.toFixed(2) || selectedShipping?.price?.toFixed(2)}</span>
                                ) : (
                                    <span className={styles.calcPending}>A calcular</span>
                                )}
                            </div>

                            <div className={styles.couponBox}>
                                <label className={styles.couponLabel}>Cupom de desconto</label>

                                <div className={styles.couponRow}>
                                    <input
                                        type="text"
                                        placeholder="Digite seu cupom"
                                        value={couponCode}
                                        onChange={(e) => setCouponCode(e.target.value)}
                                        className={styles.couponInput}
                                    />

                                    <button
                                        type="button"
                                        onClick={applyCoupon}
                                        disabled={couponLoading}
                                        className={styles.couponBtn}
                                    >
                                        {couponLoading ? 'Aplicando...' : 'Aplicar'}
                                    </button>
                                </div>

                                {couponError && (
                                    <small className={styles.couponError}>{couponError}</small>
                                )}

                                {couponData && (
                                    <small className={styles.couponSuccess}>
                                        Cupom aplicado! -R$ {discountValue.toFixed(2)}
                                    </small>
                                )}
                            </div>


                            <div className={styles.divider}></div>

                            {couponData && (
                                <div className={styles.summaryLine}>
                                    <span>Desconto</span>
                                    <span>- R$ {discountValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                                </div>
                            )}


                            <div className={styles.totalLine}>
                                <div className={styles.totalLabels}>
                                    <strong>TOTAL</strong>
                                    <small>em até 12x no cartão</small>
                                </div>
                                <span className={styles.totalValue}>
                                    R$ {totalWithDiscount.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                </span>
                            </div>

                            <button className={styles.checkoutBtn} onClick={() => navigate('/mostrar-frete')}>
                                FINALIZAR COMPRA
                            </button>

                            <div className={styles.trustGroup}>
                                <div className={styles.trustItem}>
                                    <FaShieldHalved /> <span>Garantia Jungle de 1 Ano</span>
                                </div>
                                <div className={styles.trustItem}>
                                    <FaLock /> <span>Checkout Seguro & Criptografado</span>
                                </div>
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    );
}

export default CartPage;